export class ResumableEvent {
    constructor({ transfer }) {
        this.name = 'resumable';
        this.transfer = { ...transfer };
    }
    get data() {
        return {
            transfer: this.transfer,
        };
    }
}
